import React from 'react';
import map from 'lodash/map';
import { useNavigation } from 'react-day-picker';
import { useWindowSize } from '@yme/common/hooks';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { useDropdown } from './DropdownContext';
import { MonthCell } from './MonthsCell';
import { getGroupedMonths } from './helpers';
export function MonthsGrid({ year }) {
    const { goToMonth } = useNavigation();
    const { toggleDropdown } = useDropdown();
    const { isInfiniteDesktopView } = useWindowSize();
    const monthsAmount = isInfiniteDesktopView ? 4 : 6;
    return (React.createElement(React.Fragment, null, map(getGroupedMonths(monthsAmount), (row, index) => (React.createElement(FlexWrapper, { key: index }, map(row, ({ monthIndex, monthLabel }) => (React.createElement(MonthCell, { key: monthLabel, year: year, monthIndex: monthIndex, monthLabel: monthLabel, goToMonth: goToMonth, toggleDropdown: toggleDropdown }))))))));
}
